import { CombinationComparisonsView } from "../view/combination_comparisons_view";
import $ from "jquery";
import { Keyword } from "../view/keyword";
import { DataDate } from "../model/data_date";

class CombinationComparisonsController {
  form: Form;
  view: CombinationComparisonsView;

  constructor() {
    this.form = new Form();
    this.view = new CombinationComparisonsView(this.form.element());
  }

  onLoad() {
    this.form.initialize();
    this.view.initialize(this.form.invalidParameterCombinations() || []);
    this.render();
  }

  render() {
    if (this.form.keyword.isNotFound()) {
      this.view.showKeywordNotFoundMessage(this.form.keyword.value());
      return;
    }
    const query = new CharacteristicsQuery(this.form);
    query.execute().then(
      (html: string) => {
        const $htmlElement = $(html);
        if ($.isEmptyObject(html) || $htmlElement.find("tbody").length === 0) {
          this.view.showNoCombinationsMessage();
          return;
        }
        this.view.render(html);
      },
      (res: any) => {
        this.view.showHttpErrorMessage(res);
      },
    );
  }
}

class Form {
  keyword: any;

  element() {
    return $("#combination_comparisons_form");
  }

  constructor() {
    this.keyword = new Keyword($("#keyword"));
  }

  initialize() {
    this.keyword.initialize();
  }

  onSubmit(f: (e: JQuery.SubmitEvent) => void) {
    this.element().submit((e) => f(e));
  }

  invalidParameterCombinations() {
    return this.element().data("invalidParameterCombinations");
  }

  canvasElement() {
    return $("#characteristics_graph");
  }
  stderrElement() {
    return $("#error_message_placeholder");
  }
  ajaxUrl() {
    return this.canvasElement().data("ajaxUrl");
  }
  targetDataDate() {
    return DataDate.parseYMD(
      $("#target").val()?.toString(),
      this.partition()?.toString(),
    );
  }

  type() {
    return $("#type").val();
  }
  partition() {
    return $("#partition").val();
  }
  dimension() {
    return $("#dimension").val();
  }
  area() {
    return $("#area").val();
  }
  category() {
    return $("#category").val();
  }
  order() {
    return $("#order").val();
  }
}

class CharacteristicsQuery {
  form: Form;
  constructor(form: Form) {
    this.form = form;
  }

  execute() {
    return $.ajax({
      url: this.form.ajaxUrl(),
      data: this.makeParams(),
      dataType: "html",
    });
  }

  makeParams() {
    return {
      type: this.form.type(),
      target: this.form?.targetDataDate()?.ymd(),
      partition: this.form.partition(),
      dimension: this.form.dimension(),
      area: this.form.area(),
      category: this.form.category(),
      order: this.form.order(),
    };
  }
}

export { CombinationComparisonsController };
